import { BaseServiceClass } from './base-service';
import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { CreatePositionRequest } from 'app/model/request/create-position.request';
import { PositionResponse } from 'app/model/response/position.response';
import { Observable } from 'rxjs';
import { AssignPositionRequest } from 'app/model/request/assign-position.request';
import { UpdatePositionRequest } from 'app/model/request/update-position.request';

@Injectable({
	providedIn: 'root'
})
export class PositionsService extends BaseServiceClass<any> {

	constructor(private http: HttpClient, private router: Router, @Inject(DOCUMENT) private document: Document) {
		super(http, '/api/v1/positions');
	}

  public createPosition(request: CreatePositionRequest): Observable<PositionResponse> {
    return this.http.post<PositionResponse>(`${this.entity_url}`, request);
  }

  public updatePosition(positionId: string, request: UpdatePositionRequest): Observable<PositionResponse> {
    return this.http.put<PositionResponse>(`${this.entity_url}/${positionId}`, request);
  }

  public deletePosition(positionId: string): Observable<any> {
    return this.http.delete<any>(`${this.entity_url}/${positionId}`);
  }

  public getPositions(): Observable<PositionResponse[]> {
    return this.http.get<PositionResponse[]>(`${this.entity_url}`);
  }
}